<template>
  <aside class="menu-l">
    <h6>{{permisos.length > 0 ? 'Menú' : ''}}</h6>
    <router-link v-for="permiso in permisos" :key="permiso.ModuloId" :to="permiso.RutaDeAcceso">
      <i v-if="permiso.Icono != null && permiso.Icono != ''" :class="permiso.Icono"></i>
      <h5 class="d-none d-sm-none d-md-none d-lg-block">{{permiso.Nombre}}</h5>
      <ul v-if="permiso.Funciones != null && permiso.Funciones != undefined && permiso.Funciones.length > 0">
        <li v-for="funcion in permiso.Funciones" :key="funcion.FuncionId + '_' + funcion.Nombre">
          <router-link :to="permiso.RutaDeAcceso + funcion.RutaDeAcceso">
            <i v-if="funcion.Icono != null && funcion.Icono != ''" :class="funcion.Icono"></i>{{funcion.Nombre}}
          </router-link>
        </li>
      </ul>
    </router-link>
  </aside>
</template>

<script>
  export default {
    computed: {
      permisos() {
        const permisosDelSistema = this.$store.state.Login_PermisosDelSistema
        if(permisosDelSistema != undefined && permisosDelSistema != null)
          return permisosDelSistema
        else 
          return []
      }
    }
  }
</script>

<style>
.menu-l{
  background-color: rgb(0,117,115);
}
@media(max-width: 991px) {
  .menu-l {
    width: 80px;
    text-align: center !important;
  }

  .menu-l h6 {
    width: 100% !important;
    padding-left: 0;
    text-align: center !important;
  }

  .menu-l ul {
    left: 80px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Comunes/MenuIzquierdaDeLosSistemas.vue